<template>
  <div id="app">
    <!-- <router-view></router-view>-->
    <div v-if="$route.path !== '/about'">
      
      <!-- <app-header class=""></app-header> -->
      
      <div class="non-footer-content">
        
        <!-- <div v-if="$route.fullPath == '/'">
          <app-gameLauncher :routeRoomID="$route.params.roomID" :routeGSheetID="$route.params.gSheetID" :routeGameType="$route.params.gameType"></app-gameLauncher>
        </div> -->

        <div v-if="$route.fullPath == '/'">
          <app-homepage :routeRoomID="$route.params.roomID" :routeGSheetID="$route.params.gSheetID" :routeGameType="$route.params.gameType"></app-homepage>
        </div>

        <div v-if="$route.fullPath == '/Formats/'">
          <app-formatsAndExtensions></app-formatsAndExtensions>
        </div>

        <div v-if="$route.fullPath == '/Gallery/'">
          <app-gallery></app-gallery>
        </div>

        <div v-if="$route.fullPath == '/Grants/'">
          <app-grants></app-grants>
        </div>

        <div v-if="$route.fullPath == '/Upload/'">
          <app-uploadPage :routeRoomID="$route.params.roomID" :routeGSheetID="$route.params.gSheetID" :routeGameType="$route.params.gameType"></app-uploadPage>
        </div>
        
        <div v-if="!['Games', 'Grants', 'Gallery', 'Formats', 'Upload'].includes($route.params.gameType)">
          <!--For published version, remove any components you aren't using -->
          <div v-if="!$route.params.roomID && $route.params.gSheetID">
            <app-gameLauncher :routeGSheetID="$route.params.gSheetID" :routeGameType="$route.params.gameType"></app-gameLauncher>
          </div>

          <!-- <app-timed :roomID="$route.params.roomID" :gSheetID="$route.params.gSheetID" v-if="$route.params.gameType=='Timed' && $route.params.roomID"></app-timed> -->
          <app-shuffled ref="shuffled" :roomID="$route.params.roomID" :gSheetID="$route.params.gSheetID" :userRole="$route.params.userRole" v-if="$route.params.gameType=='Shuffled' && $route.params.roomID"></app-shuffled>
          <!-- <app-monster :roomID="$route.params.roomID" :gSheetID="$route.params.gSheetID" v-if="$route.params.gameType=='Monster' && $route.params.roomID"></app-monster>
          <app-secretCards :roomID="$route.params.roomID" :gSheetID="$route.params.gSheetID" v-if="$route.params.gameType=='SecretCards' && $route.params.roomID"></app-secretCards>
          <app-slotMachine :roomID="$route.params.roomID" :gSheetID="$route.params.gSheetID" v-if="($route.params.gameType=='SlotMachine' || $route.params.gameType=='Composite') && $route.params.roomID"></app-slotMachine>
          <app-phases :roomID="$route.params.roomID" :gSheetID="$route.params.gSheetID" v-if="$route.params.gameType=='Phases' && $route.params.roomID"></app-phases> -->
          <app-generator :roomID="$route.params.roomID" :gSheetID="$route.params.gSheetID" v-if="$route.params.gameType=='Generator' && $route.params.roomID"></app-generator>
          <!-- <app-hexflower :roomID="$route.params.roomID" :gSheetID="$route.params.gSheetID" v-if="$route.params.gameType=='Hexflower' && $route.params.roomID"></app-hexflower>
          <app-gridmap :roomID="$route.params.roomID" :gSheetID="$route.params.gSheetID" v-if="$route.params.gameType=='Gridmap' && $route.params.roomID"></app-gridmap> -->

          <!-- <app-sandbox :roomID="$route.params.roomID" :gSheetID="$route.params.gSheetID" v-if="$route.params.gameType=='Sandbox' && $route.params.roomID"></app-sandbox> -->
        </div>
        <div v-else-if="$route.params.gameType == 'Games'">
          <div v-if="!$route.params.roomID && $route.params.gSheetID">
            <app-customGameLauncher :routeGSheetID="$route.params.gSheetID" :routeGameType="$route.params.gameType"></app-customGameLauncher>
          </div>
          <app-customGameSessionManager :routeGSheetID="$route.params.gSheetID" v-if="$route.params.roomID" :userRole="$route.params.userRole"></app-customGameSessionManager>
        </div>
      </div>
      
      <app-footer v-if="$route.params.roomID && ['Timed', 'SecretCards'].includes($route.params.gameType)"></app-footer>
    </div>
  </div>
</template>

<script>
  import firebase from 'firebase'

  // Remove for published version any components you aren't using
  // import Header from './components/layout/Header.vue'
  // import Footer from './components/layout/Footer.vue'

  import Homepage from './components/other/Homepage.vue'
  // import Gallery from './components/other/Gallery.vue'
  // import FormatsAndExtensionsOverview from './components/other/FormatsAndExtensionsOverview.vue'
  // import Grants from './components/other/Grants.vue'

  // import UploadPage from './components/launchers/UploadPage.vue'
  import GameLauncher from './components/launchers/GameLauncher.vue'
  import CustomGameLauncher from './components/games/CustomGameLauncher.vue'
  import CustomGameSessionManager from './components/games/CustomGameSessionManager.vue'

  // import Timed from './components/formats/Timed.vue'
  import Shuffled from './components/formats/Shuffled.vue'
  // import Monster from './components/formats/Monster.vue'
  // import SecretCards from './components/formats/SecretCards.vue'
  // import SlotMachine from './components/formats/SlotMachine.vue'
  // import Phases from './components/formats/Phases.vue'
  import Generator from './components/formats/Generator.vue'
  // import Gridmap from './components/formats/Gridmap.vue'
  // import Hexflower from './components/formats/Hexflower.vue'
  // import Sandbox from './components/formats/Sandbox.vue'

  export default {
    name: 'app',
    components: { // Remove unused components from the published version
      // 'app-header': Header,
      // 'app-footer': Footer,

      'app-homepage': Homepage,
      // 'app-grants': Grants,
      // 'app-gallery': Gallery,
      // 'app-formatsAndExtensions': FormatsAndExtensionsOverview,

      // 'app-uploadPage': UploadPage,
      'app-gameLauncher': GameLauncher,
      'app-customGameLauncher': CustomGameLauncher,
      'app-customGameSessionManager': CustomGameSessionManager,

      // 'app-timed': Timed,
      'app-shuffled': Shuffled,
      // 'app-monster': Monster,
      // 'app-secretCards': SecretCards,
      // 'app-slotMachine': SlotMachine,
      // 'app-phases': Phases,
      'app-generator': Generator,
      // 'app-gridmap': Gridmap,
      // 'app-hexflower': Hexflower,
      // 'app-sandbox': Sandbox,
      
    },
    data () {
      return {
      }
    },
    metaInfo () {
    return {
      title: "Story Synth",
      meta: [
        {
          property: 'description',
          content: 'A platform for designing and playing storytelling games online. Free to use, open source, no coding knowledge needed.',
          vmid: 'description'
        },
        {
          property: 'og:title',
          content: 'Story Synth',
          vmid: 'og:title'
        },
        {
          property: 'og:description',
          content: 'A platform for designing and playing storytelling games online.',
          vmid: 'og:description'
        },
        {
          property: 'og:image',
          content: 'https://storysynth.org/img/story-synth-square-logo.gif',
          vmid: 'og:image'
        },
        {
          property: 'og:url',
          content: 'https://storysynth.org/',
          vmid: 'og:url'
        },
        {
          property: 'twitter:card',
          content: 'summary',
          vmid: 'twitter:card'
        },
        {
          property: 'og:site_name',
          content: 'Story Synth',
          vmid: 'og:site_name'
        },
        {
          property: 'twitter:image:alt',
          content: 'The Story Synth Logo',
          vmid: 'twitter:image:alt'
        },
        {
          name: 'monetization',
          content: '$ilp.uphold.com/WMbkRBiZFgbx',
          vmid: 'monetization'
        },
        
      ]
    }
  },
    mounted () {
      firebase.auth().signInAnonymously()
      .then(() => {
        //console.log('anon auth')
      })
      .catch((error) => {
        var errorCode = error.code;
        var errorMessage = error.message;
        console.log(errorCode, errorMessage)
        // ...
      });

    },
    methods: {
    }
  }
</script>

<style lang="scss">

$dark-blue: #323c69;
  $light-blue: #d9fcfd;

  a {
    color: #0071EB;
  }

  html {
    height: 100%;
    // overflow: -moz-scrollbars-vertical; 
    // overflow-y: scroll;
  }


  .btn-outline-dark:not(:hover), .btn-outline-primary:not(:hover) {
    background-color:white;
  }

  .menu-bar .btn-outline-dark:not(:hover), .menu-bar .btn-outline-primary:not(:hover) {
    background-color: transparent;
  }

  .message{
    font-size: 2em;
    margin-top: 1em;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }

  .app-main {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #000d1b;
    z-index: -1;
    
    position: relative;
    min-height: 100vh;
  }

  .game-room {
    text-align: center;
    max-width:600px;
  }

  body {
    // background: var(--light);
    margin: auto;
    // background-repeat: no-repeat;
    // background-attachment: fixed;
    touch-action: manipulation;
    // overflow: hidden;
  }

  h1, h2 {
    font-weight: normal;
  }

  ul {
    padding: 0;
  }

  ul.dropdown-menu > li{
    list-style-type: none;
  }

  li {

    list-style-type: disc;
    display: list-item;
    margin-left: 1.2rem
    
  }


  .margin-between-sections {
    // margin-bottom: 116px;
  }

  .padding-after-navbar {
    padding-top: 124px;
  }
  .navbar {
    backdrop-filter: blur(10px);
    width: 100%;
  }
  ul.navbar-nav {
    list-style-type: none;
  }

  li.nav-item {
    display: inline-block;
    // margin: 0 10px;
  }

  .app-main .shadow {
    // box-shadow:
    //   0 1px 1px hsl(0deg 0% 0% / 0.075),
    //   0 2px 2px hsl(0deg 0% 0% / 0.075),
    //   0 4px 4px hsl(0deg 0% 0% / 0.075),
    //   0 8px 8px hsl(0deg 0% 0% / 0.075),
    //   0 16px 16px hsl(0deg 0% 0% / 0.075) !important
    // ;
  }

  .extension h2 {
    font-size: 1.5rem;
  }

  .non-footer-content {
    // padding-bottom: 8.5rem;
  }

  .demoInfo {
    a {
      color: black;
    }
  }

  // Utility classes  
  :root {
    --ds-rounding: 14px;
  }  
  .rounded-m {
    border-radius: var(--ds-rounding);
  }
  .clipped {
    // overflow: hidden;
  }
  .card {
    border-radius: var(--ds-rounding);
    // overflow: hidden;
  }
  .card-img {
    border-radius: 0;
  }

.btn-fab.shadow {
  border-width: 0;
  // box-shadow:
  //     0 1px 1px hsl(0deg 0% 0% / 0.075),
  //     0 2px 2px hsl(0deg 0% 0% / 0.075),
  //     0 4px 4px hsl(0deg 0% 0% / 0.075),
  //     0 8px 8px hsl(0deg 0% 0% / 0.075),
  //     0 16px 16px hsl(0deg 0% 0% / 0.075),
  //     0 0px 5px hsl(0deg 0% 0% / .15) !important
  //   ;
}
.btn-fab:not(:hover) {
  background: white;
}
.btn-fab svg {
  transition: transform 0.2s;
}
.btn-fab:hover:not([disabled="disabled"]) svg {
  transform: scale(1.1);
}
.btn-fab[disabled="disabled"] {
  background: white;

  svg{
    color: var(--secondary);
  }
}

@media (max-width: 800px) {
  .fab-buttons {
    position: fixed;
    width: calc(100vw - 30px);
    z-index: 100000;
    bottom: 48px;
  }
  .btn-fab {
    --fab-diameter: 90px;  
    --fab-spacing: 28px;  
    border-radius: var(--fab-diameter); 
    width: var(--fab-diameter); 
    height: var(--fab-diameter); 
    
    // &.btn-fab-left {
    // 
    // }

    &.btn-fab-right {
      margin-left: var(--fab-spacing);
    }
  }
}
@media (min-width: 800px) {
  .fab-buttons {
    position: relative;
    width: 100%;
  }
  .btn-fab {
    --fab-diameter: 90px;  
    border-radius: var(--fab-diameter); 
    width: var(--fab-diameter); 
    height: var(--fab-diameter); 
    margin-top: 120px;
    position: absolute;
    
    &.btn-fab-left {
      left: calc(-20px - var(--fab-diameter));
    }
    &.btn-fab-right {
      right: calc(-20px - var(--fab-diameter));
    }
  }
}

.menu-row {
  justify-content: center;
  margin-bottom: 10px;
}

.demoInfo, .alert-info {
    color: #0c5460;
    background-color: #d1ecf1;
    // border-color: #bee5eb;
    text-shadow: none !important;

    a {
      color: #0071EB !important;
    }
}

.edit-button {
  border: none;
}

img {
    max-width: 100%;
    height: auto;
  }

// margin calls from Generator

.mb-2 {
    margin-bottom: 0rem !important;
}
.mt-1 {
    margin-top: 1rem !important;
}

.mb-3 {
    margin-bottom:0rem!important;
}
.mb-4 {
    margin-bottom:0rem!important;
}
.mt-4 {
    margin-top:0rem!important;
}

.pl-3 {
    padding:0rem!important;
}

.pr-3 {
    padding:0rem!important;
}

.px-3 {
    padding:0rem!important;
}
.px-4 {
    padding:0rem!important;
}


// from Generator
// @font-face {
// font-family: metal-blackletter;
// src: url('/fonts/Metal-Blackletter.woff');
// }
// @import url('https://fonts.googleapis.com/css2?family=Courier+Prime&display=swap');

// :root {
//   --rotValueName: -3deg;
// }

// $base-color: rgb(33, 33, 33);

// .game-room {
//   padding-top: 20px;
//   max-width: 1500px !important;
// }
// .generator-main {
//   font-weight: normal;  
//   border-radius: 5px;
//   color: white;
//   position: fixed; 
//   overflow-y: scroll;
//   top: 0; right: 0; bottom: 0; left: 0;
//   padding-top: 250px;
//   z-index: -1;
//   // margin-top: 400px;
//   padding-left: 25%;
//   padding-right: 25%;
//   clip-path: inset(250px 0px 0px 0px);
// }
// .container {
//     // margin-left:25% !important;
//     // margin-right:25% !important;
//     // clip-path: inset(300px 0px 0px 0px);
// }

// .button {
//   padding-top: 0px !important;
//   padding-bottom: 0px !important;
//   // overflow: hidden !important;
// }

// @media (max-width: 575px) {  
//   .generator-cell-body {
//     font-size:1rem !important;
//     // font-weight: 500 !important;  
//   } /*1rem = 16px*/

//   .generator-cell-reroll-button {
//     display: none;
//   }

// }

// // select {
// //   width: auto;
// // }

// // CELL
// .generator-cell {
//   position: relative;
//   border-top: 0px;
//   border-right: 0px;
//   border-left: 0px;
//   border-bottom: 0px;
//   display: inline-flex; /* keep the inline nature of buttons */
//   align-items: center; /* this is default */  
//   font-family: inherit;
//   font-size: 100%;
//   background: inherit;
//   color: inherit;
//   transition: background-color 0.2s;
//   transition: all 0.3s;  
//   white-space: nowrap;
//   // overflow: hidden;
//   outline-offset: -5px;
//   padding: 0px !important;
//   // z-index: -1;
// }

// .generator-cell:not(.generator-cell-row-end) {    
//   // border-right: 1px solid rgba($base-color, 0.1);
// }  

// // .generator-cell:hover {

// //   .generator-cell-contents {
// //     transform: scale(1.04);
// //   }

// //   .generator-cell-reroll-button {
// //     opacity: 0.5;
// //   }
// // }

// .generator-cell:focus {
//   // outline: 1px solid rgba(255, 255, 255, 0.25);
//   // outline-offset: -1px;
//   .generator-cell-reroll-button {
//     opacity: 0.5;
//   }  
// }

// .generator-cell-contents {
//   // width: 100%;
//   max-width: 100%;
//   height: auto;
//   // white-space: pre-line;
//   display: flex;
//   align-items: center;
//   flex-direction: column;
//   transition: all 0.3s;  
//   // z-index: -1 !important;
// }

// // .generator-cell-arrow {
// //   .generator-cell-contents {
// //     width: 25%;
// //   }
// // }

// // .generator-cell-main {
// //   .generator-cell-contents {
// //     width: 100%;
// //   }
// // }

// // .generator-cell:hover {

// //   .generator-cell-contents {
// //     transform: scale(1.04);
// //   }

// //   .generator-cell-reroll-button {
// //     opacity: 0.5;
// //   }
// // }

// .generator-cell-arrow {
//   max-width: 5%;
//   cursor: pointer;
// }
// .generator-cell-arrow:hover {
//   .generator-cell-contents {
//     transform: scale(1.5);
//   }
// }
// .generator-cell-name {
//   cursor: default;
//   min-width: 90%;
//   max-width: 90%;
//   // min-height:100px;
//   // max-height:100px;
//   height: 100%;
// }
// .generator-cell-main {
//   cursor: default;
//   min-width: 40%;
//   max-width: 40%;
//   // min-height: 203px;
//   // max-height: 203px;
//   height: 100%;
// }

// .generator-cell-legs {
//   cursor: default;
//   min-width: 40%;
//   max-width: 40%;
//   // min-height: 313px;
//   // max-height: 313px;
//   height: 100%;
// }

// // CELL LABEL
// .generator-cell-label {
//   display: none !important;
//   // background: var(--dark);
//   // color: white;  
//   background: var(--yellow);
//   // border-bottom: 4px solid var(--dark);
//   text-transform: uppercase;
//   padding-top: 0px;
//   padding-bottom: 0px;
//   transition: all 0.2s;
//   font-size: 0.8em;
//   // font-weight: bold;
// }

// //randomize all button
// .btn {
//   background-color:#f5eb14;
//   // font-family: 'Courier Prime', monospace;
//   font-family: metal-blackletter;
//   font-size: 1.2em;
//   color: black;
//   // position: fixed;
//   // z-index: 0 !important;
//   border: 0px !important;
//   border-radius: 0px !important;
// }

// .btn:hover {
//   // background-color:#ff5792;
//   background-color:#c3be00;
// }


// // CELL BODY
// .generator-cell-body {
//   flex-grow: 1;
//   transition: all 0.2s;
//   // font-weight: 500;
// }
// .generator-cell-name {
//   .generator-cell-body {
//     display: table;
//     margin: 0px auto 0px auto;
//     padding-right:10px;
//     padding-left:10px;
//     padding-top:5px;
//     // font-size:20px;
//     background-color:#ff7bab;
//     font-size: 2em;
//     font-family: metal-blackletter;
//     transform: rotate(calc(0deg - var(--rotValueName)))!important;
//     // font-weight: 600;
//   }
// }
// .generator-cell-full {
//   .generator-cell-body {
//     font-size: 2em; 
//   }
//   .generator-cell-full-small {
//     font-size: 1.2em;
//     font-weight: 600;
//   }
// }

// .generator-cell-one-half {
//   .generator-cell-body {
//     font-size: 1.1em;
//     font-weight: 600;
//   }
// }
// .generator-cell-one-third {
//   .generator-cell-body {
//     font-size: 1.1em;
//     font-weight: 600;
//   }  
// }
// .generator-cell-one-quarter {  
//   .generator-cell-body {
//     font-size: 0.9em;
//     font-weight: 600;
//   }
// }


// // CELL REROLL BUTTON
// .generator-cell-reroll-button {
// display: none !important;
// // margin-top: 8px;
//   // text-transform: uppercase;
//   // font-size: 0.8em;
//   // transition: opacity 0.25s;
//   // opacity: 0;
// }

// ////////////////////////////////

// .slot-machine {
//   margin: auto;
//   // padding-top: 1em;
//   // padding-bottom: 1em;
// }

// .card-body {
//   font-size: 1.5em;
//   min-height: 11em;
// }

// .fade-enter-active,
// .fade-leave-active {
//   transition: opacity 0.5s;
// }
// .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
//   opacity: 0;
// }

// // Reroll transition
// .reroll-enter-active,
// .reroll-leave-active {
//   transition: all .5s;

// }
// .reroll-enter, .reroll-leave-to /* .fade-leave-active below version 2.1.8 */ {

//   .generator-cell-label {
//     // transform: scale(1.025);
//     transition: transform 0.5s;
//     transform: translateY(0px) scale(1.05);
//   }

//   .generator-cell-body {
//     // transition-delay: 0.25s;
//     opacity: 0;
//     transform: scale(0.9);
//   }

//   .generator-cell-reroll-button {
//     transition: transform 0.5s;
//     transform: scale(1.1);
//   }

//   .generator-cell-reroll-icon {
//     transition: transform 0.5s;
//     transform: rotate(360deg)
//   }

// }

// .reroll-list-enter-active {
//   transition: all .5s;
// }
// .reroll-list-leave-active {
//  transition: all 0s;
// }

// .reroll-list-enter, .reroll-list-leave-to /* .list-leave-active below version 2.1.8 */ {
//   opacity: 0;
// }

// .reroll-list-move {
//   transition: transform 1s;
// }

// .x-card-text {
//   font-size: 0.5em;
//   text-decoration: underline;
// }

// .full-page-background {
//   position: absolute;
//   height: 100%;
//   width: 100vw;
//   top: 0;
//   right: 0;
//   margin: 0;
//   z-index: -1;
// }

// .generator-row {
//   padding: 15px !important;
// }
// .generator-row-one-sixth { 
//   padding: 15px !important; 
// }
// .mb-2 {
//     margin-bottom: 0rem !important;
// }

// .mb-3 {
//     margin-bottom:0rem!important;
// }
// .mt-4 {
//     margin-top:0rem!important;
// }

// .pl-3 {
//     padding:0rem!important;
// }

// .pr-3 {
//     padding:0rem!important;
// }

// .px-3 {
//     padding:0rem!important;
// }

// .card {
//     border:0px !important;
//     background-color: transparent;
// }

// // from TheDoctorIsGone

// @import url('https://fonts.googleapis.com/css2?family=Bodoni+Moda&display=swap');
// @import url('https://fonts.googleapis.com/css2?family=Courier+Prime&display=swap');
// @font-face {
// font-family: metal-blackletter;
// src: url('/fonts/Metal-Blackletter.woff');
// }


// :root {
//   --rotValue: -3deg;
// }

// .shuffled {
//   // margin: auto;
//   // padding-top: 1em;
//   // padding-bottom: 1em;
//     transition: all 0.3s;
//     transition: transform 0.3s;  
// }

// .game-meta {
//   font-family: metal-blackletter;
//   color: #ff7bab;
// }

// h1 {
//   font-family: metal-blackletter !important;
//   color: #ff7bab !important;
//   margin-bottom: 0em;
//   line-height: 0.2em;
// }

// .card {
//   background-color:rgba(0, 0, 0, 0.5);
//   min-height: 200px; 
//   // max-height: 200px;
//   max-width: 600px !important;
//   margin-left: auto;
//   margin-right: auto;
//   margin-top: 25px;
//   border: 0px !important;
//   transform: rotate(calc(0deg - var(--rotValue)))!important;
//   transition: all 0.3s;
//   transition: transform 0.3s;
//   // opacity: 0.5;  
// }

// .shadow {
//   box-shadow: 0 0 0 0 !important;
// }

// .game-room {
//   // padding-top: 20px;
//   max-width: 1150px !important;
// }
// @media (max-width: 576px) {
//   h1,
//   h2 {
//     font-size: 1.5em;
//   }

//   .card-body {
//     color: #f5eb14;
//     font-size: 1.2em;
//     // max-height: 200px !important;
//     // min-height: 11em;
//     font-family: 'Courier Prime', monospace;
//     line-height: 200px;
//     padding: 0px !important;
//     display: table;
//     transition: transform 0.3s;
//   }

//   .card-body p {
//     line-height: 1.5;
//     display: inline-block;
//     vertical-align: middle;
//     // margin: 0px auto 0px auto;
//     // padding-right:10px;
//     // padding-left:10px;
//     // padding-top:5px;
//     // // font-size:20px;
//     // background-color:#ff7bab;
//   }
// }

// @media (min-width: 576px) {
//   .card-body {
//     color: #f5eb14;
//     font-size: 1.5em;
//     // min-height: 11em;
//     max-height: 200px !important;
//     font-family: 'Courier Prime', monospace;;
//     line-height: 200px;
//     // padding: 0px !important;
//     display: table;
//   }
//     .card-body p {
//     line-height: 1.5;
//     display: inline-block;
//     vertical-align: middle;
//     // margin: 0px auto 0px auto;
//     // padding-right:10px;
//     // padding-left:10px;
//     // padding-top:5px;
//     // // font-size:20px;
//     // background-color:#ff7bab;
//   }
// }

// .menu-bar {
//   color: #ff7bab !important;
//   font-family: metal-blackletter;
//   // font-size: 1.5em !important;
// }

// .btn {
//   background-color:#ff7bab;
//   // font-size: 1.2em !important;
// }

// .btn-outline-dark {
//   font-size: 1.2em !important;
//   :hover {
//   background-color:#ff7bab;
// }
// }

// .control-button-next-card {
//   background-color:#ff7bab;;
// }

// .deck-number-1 {
//   max-height: 200px;
// }

// .fade-enter-active,
// .fade-leave-active {
//   transition: opacity 0.2s;
//   transition: all 0.2s;
//   transition: transform 0.2s;  
// }
// .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
//   opacity: 0;
//   transition: all 0.2s;
//   transition: transform 0.2s;  
// }
// .x-card-text {
//   font-size: 0.5em;
//   text-decoration: underline;
// }

// .full-page-background {
//   position: absolute;
//   height: 100%;
//   width: 100vw;
//   top: 0;
//   right: 0;
//   margin: 0;
//   z-index: -2;
//   background-color:#8422E5;
//   background-image:url(/images/graphics/anatomy-background-empty.png);
//   background-size:cover;
//   background-attachment: fixed;
//   background-repeat:repeat-y;
// }

// .mb-4 {
//   margin-bottom: 0px !important;
// }

// .mt-4 {
//   margin-top: 0px !important;

// .mb-2 {
//     margin-bottom: 0rem !important;
// }

// .mb-3 {
//     margin-bottom:0rem!important;
// }
// .mt-4 {
//     margin-top:0rem!important;
// }

// .pl-3 {
//     padding:0rem!important;
// }

// .pr-3 {
//     padding:0rem!important;
// }

// .px-3 {
//     padding:0rem!important;
// }
// }

// // from Homepage

// .homepage {
//   max-width: 800px;
//   margin: auto;
// }

// li {
//   list-style-type: disc;
//   display: list-item;
//   margin-left: 20px;
// }

// // from style-template-homepage

// h1,
//   h2,
//   h3,
//   h4 {
//     font-family: metal-blackletter;
//     // font-weight: bold;
//     text-align: center;
//     color: #ff7bab;
//   }

//   h2 {
//     font-size: 2.75rem;
//   }

//   a {
//     color: #003daf;
//     &:hover {
//       text-decoration: underline;
//     }
//   }

//   button,
//   a.btn {
//     // font-weight: bold;
//     // background: $dark-blue;
//     // color: $light-blue;
//     cursor: pointer;
//     text-decoration: none;

//     // &:hover:not(.button-light) {
//     //   background-color: darken($dark-blue, 8%);
//     // }
//     // &:active {
//     //   background-color: darken($dark-blue, 20%);
//     // }
//     &:disabled {
//       cursor: default;
//     }
//   }
  
//   .button-light {
//     // background: $light-blue;
//     // font-weight: bold;
//     // color: $dark-blue;
//     font-family: "Courier Prime", monospace;
//     cursor: pointer;
//     text-decoration: none;

//     // &:hover:enabled {
//     //   background-color: darken($light-blue, 8%);
//     // }
//     // &:active:enabled {
//     //   background-color: darken($light-blue, 20%);
//     // }
//   }

//   .card {
//     text-align: center;
//     font-family: "Courier Prime", monospace;
//     color: black;
//     background-color:rgba(0, 0, 0, 0.5);

//     a.btn {
//       // background: $light-blue;
//       // font-weight: bold;
//       // color: $dark-blue;
//       font-family: "Courier Prime", monospace;
//       cursor: pointer;
//       text-decoration: none;

//       // &:hover {
//       //   background-color: darken($light-blue, 8%);
//       // }
//       // &:active {
//       //   background-color: darken($light-blue, 20%);
//       // }
//     }
//   }


//   .navbar {
//     transition: all 0.2s;
//   }
//   .navbar:not(.scrolledNavbar) {
//     background-color: transparent !important;
//   }
//   .navbar-brand,
//   .nav-item,
//   .nav-link {
//     // color: $dark-blue !important;
//     font-family: "Courier Prime", monospace;
//     color: #f5eb14;

//     :hover {
//       text-decoration: underline !important;
//     }
//   }

//   img {
//     max-width: 100%;
//     height: auto;
//   }


//   .navbar.scrolledNavbar {
//     background-color: $dark-blue !important;
//     // animation: navbarFade 0.5s forwards;
//   }

//   // @keyframes navbarFade {
//   //   0% {
//   //     background-color: transparent !important;
//   //   }

//   //   100% {
//   //     background-color: $dark-blue !important;
//   //   }
//   // }

//   .scrolledNavbar {
//     .navbar-brand,
//     .nav-item,
//     .nav-link {
//       color: $light-blue !important;
//       font-family: "Courier Prime", monospace;
//       color: #f5eb14;

//       :hover {
//         text-decoration: underline !important;
//       }
//     }
//   }


</style>
